module.exports = __webpack_public_path__ + "img/低压电池1.5f0e36fc.png";